

import React, { useEffect, useState } from "react";
import axios from "axios";
import Boxvalue from "../ReportTab/Boxvalue";
import Charts from "../ReportTab/Charts";
import LineCharts from "../ReportTab/LineCharts";
import heartLoading from "../../assests/heartLoading.gif";
import StackedParentDomainChart from "../ReportTab/StackedParentDomainChart";


const BASE_URL = process.env.REACT_APP_API_URL;
const ENDPOINT = "/dq-holistic/overview";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

const OverviewPage = ({ filters, onFilterOptionsChange }) => {
  const { parentDomain, domain, subDomain, product } = filters;

  const [metrics, setMetrics] = useState([]);
  const [dqKPIScores, setDqKPIScores] = useState([]);
  const [dqScoreTrendGraph, setDqScoreTrendGraph] = useState({});


  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [domainScore, setDomainScore] = useState({});


  const items = [
    { color: "#FB0301", label: "< 90%" },
    { color: "#FFC100", label: "90% – 95%" },
    { color: "#009F52", label: "≥ 95%" },
  ];

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      const res = await axios.get(`${BASE_URL}${ENDPOINT}`, {
        params: {
          parentDomain: parentDomain === "All Parent Domains" ? "" : parentDomain,
          domain: domain === "All Domains" ? "" : domain,
          subDomain: subDomain === "All Sub Domains" ? "" : subDomain,
          product: product === "All Products" ? "" : product,
          page: DEFAULT_PAGE,
          pageSize: DEFAULT_PAGE_SIZE,
        },
      });

      setMetrics(res.data.metrics || []);
      setDqKPIScores(res.data.dqKPIScores || []);
      setDqScoreTrendGraph(res.data.dqScoreTrendGraph || {});
      setDomainScore(res.data.domain_Score || {});

      if (res.data.filters && res.data.filters.parent_domains) {
        if (typeof onFilterOptionsChange === "function") {
          onFilterOptionsChange(res.data.filters.parent_domains);
        }
      }
    } catch (err) {
      setError("Failed to fetch overview");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [parentDomain, domain, subDomain, product]);



  if (loading) {
    return (
     <div
      className="flex items-center justify-center w-full overflow-hidden"
      style={{
        minHeight: "100%",       // fills available space naturally
        marginTop: "80px",     
      }}
    >
      <div className="text-center flex flex-col items-center justify-center space-y-4">
        <img src={heartLoading} alt="Loading..." width={200} />
        <div className="space-y-2">
          <p className="text-gray-700 text-xl font-semibold">
            Applying filters...
          </p>
          <p className="text-gray-500 text-base">
            Updating results based on your selection
          </p>
        </div>
      </div>
    </div>
    );
  }

  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <>

      <div className="w-full bg-white py-6">
        <div className="w-[90%] mx-auto">
          <div className="flex gap-[8rem] items-stretch">
            <div className="basis-1/2 flex flex-col">
              <div className="flex-1 flex">
                <Boxvalue metrics={metrics} />
              </div>
            </div>

            <div className="basis-1/2 flex flex-col mt-[15px]">
              <div className="flex space-x-8 justify-around pb-2 mb-[3px]">
                {items.map((item, idx) => (
                  <div key={idx} className="flex items-center space-x-2">
                    <div
                      className="w-[14px] h-[50px] rounded-full"
                      style={{ backgroundColor: item.color.trim() }}
                    />
                    <div className="flex flex-col text-sm text-gray-500">
                      <span className="labeling-items">DQ KPI Score</span>
                      <span className="labeling-items">{item.label}</span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex-1 mt-[10px]">
                <Charts dqKPIScores={dqKPIScores} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex gap-[10px] items-stretch mt-[1rem] h-[500px]">
        <div className="w-1/2 bg-white  pl-3 pr-3 pt-2 pb-4 rounded-2xl shadow">
          <LineCharts dqScoreTrendGraph={dqScoreTrendGraph} />
        </div>

        <div className="w-1/2 bg-white pl-3 pr-3 pt-3 pb-1 rounded-2xl shadow" style={{ overflowY: "auto" }}>
          <h3 className="text-lg font-semibold text-gray-700 mb-4">
            Domain Wise Quality Score
          </h3>
          <StackedParentDomainChart domainScore={domainScore} />
        </div>
      </div>
    </>
  );
};

export default OverviewPage;
